import getHeaders from './headers';
import queryParams from './query-params';
import $ from 'jquery'

export const post = (url, data, params, _headers = {}, { responseProxy }) => {

	const headers = getHeaders(_headers);
	url = url + (params ? '?' + queryParams(params) : '');
	data = JSON.stringify(data);

	const responseSuccessProxy = (
		typeof responseProxy === 'function' ? responseProxy :
			typeof responseProxy === 'object' ? responseProxy.success :
				undefined
	);
	const responseErrorProxy = (
		typeof responseProxy === 'function' ? responseProxy :
			typeof responseProxy === 'object' ? responseProxy.error :
				undefined
	);

	return new Promise((resolve, reject) => {
		$.ajax({
			method: 'POST',
			url,
			data,
			headers,
		})
			.done(result => {
				if (responseSuccessProxy) {
					return responseSuccessProxy({
						result,
						// resolve,
						// reject,
						next: () => resolve(result),
					});
				}
				resolve(result);
			})
			.fail(error => {
				if (responseErrorProxy) {
					return responseErrorProxy({
						error: {
							status: error.status,
							responseText: error.responseText,
						},
						// resolve,
						// reject,
						next: () => reject(error),
					});
				}
				reject(error);
			});
	});
}
export default post;

const responseProxy = async () => {

}